"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import classnames from "classnames";
import nextI18NextConfig from "../../../../next-i18next.config.js";
import ArrowIcon from "../../../assets/svg/arrow-icon.svg";
import WorldIcon from "../../../assets/svg/world-icon.svg";
import "./styles.scss";

const LanguageSelector = ({
  hideLanguageSelector,
  language,
}: {
  hideLanguageSelector?: boolean;
  language: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [urlParams, setUrlParams] = useState("");
  const [pathnameUrl, setPathnameUrl] = useState("");
  const pathname = usePathname();

  const languageSelectorClassname = classnames(`LanguageSelector`, {
    "LanguageSelector--isOpen": isOpen,
    "LanguageSelector--isHideSelector": hideLanguageSelector,
  });

  const languagesIndex = [
    { code: "en-US", name: "English", nameShort: "EN" },
    { code: "es", name: "Español", nameShort: "ES" },
  ];

  // @ts-ignore
  const languages = nextI18NextConfig.locales;
  let selectedLanguage = { code: "en-US", name: "English", nameShort: "EN" };

  useEffect(() => {
    const pathWithoutLocale: string =
      language !== "en-US"
        ? "/" +
          pathname
            .split("/")
            .reduce((acc: string[], item: string, index: number) => {
              if (index > 1) acc.push(item);
              return acc;
            }, [])
            .join("/")
        : pathname;

    setUrlParams(window.location.search);
    setPathnameUrl(pathWithoutLocale);
  }, [language, pathname]);

  selectedLanguage = languagesIndex.filter((l) => l.code === language)[0] || selectedLanguage;

  const options = languages.map((languageItem: any) => {
    if (languageItem !== language) {
      const languageFullValue = languagesIndex.filter((l) => l.code === languageItem)[0];
      const finalPath = `/${languageFullValue.code}${pathnameUrl}${urlParams}`;

      return (
        <li key={languageItem}>
          <a
            className="LanguageSelector__item LanguageSelector__option"
            href={finalPath}>
            <span className="LanguageSelector__itemLabel--desktop">{languageFullValue.name}</span>
            <span className="LanguageSelector__itemLabel--mobile">
              {languageFullValue.nameShort}
            </span>
          </a>
        </li>
      );
    }
    return null;
  });

  const handlerOpen = () => {
    if (hideLanguageSelector) {
      return;
    }

    setIsOpen(!isOpen);
  };

  if (languages.length < 2) {
    return false;
  }

  return (
    <>
      <div className={languageSelectorClassname}>
        <div
          role="presentation"
          className="LanguageSelector__item LanguageSelector__current"
          onKeyDown={handlerOpen}
          onClick={handlerOpen}>
          <div data-testid="world-icon">
            <WorldIcon />
          </div>
          <span className="LanguageSelector__text LanguageSelector__text--desktop">
            {selectedLanguage.name}
          </span>
          <span className="LanguageSelector__text LanguageSelector__text--mobile">
            {selectedLanguage.nameShort}
          </span>
          {!hideLanguageSelector && (
            <div
              data-testid="arrow-icon"
              className="LanguageSelector__arrowIcon">
              <ArrowIcon />
            </div>
          )}
          {isOpen && <ul className="LanguageSelector__dropdown">{options}</ul>}
        </div>
      </div>
    </>
  );
};

export default LanguageSelector;
